export default __webpack_public_path__ + "static/media/3.8cc4aa65.jpeg";